import DownloadRow from "@/components/download_row.js";
export default function ProductAssetsTable({ downloads, resource_display, config }) {

const sharedAssetsEnabled = config?.enable_asset_multiple_link_download_modal || config?.enable_asset_multiple_link_copying_modal
  return (
    <section className="lexcms-downloads-table-container">
      <section className="lexcms-downloads-table">
        <div className="lexcms-downloads-table-header-container">
          <div className="lexcms-downloads-table-headers">
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              Image
            </p>
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              Product Name
            </p>
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              Spec Sheets
            </p>
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              Photometry
            </p>
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              Brochures
            </p>
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              Installation Guides
            </p>
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              BIM & CAD Files
            </p>
            <p
              className={
                "lexcms-downloads-table-header-values" +
                (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
              }
            >
              Sell Sheets
            </p>
            {sharedAssetsEnabled && (
              <p className="lexcms-downloads-table-header-values lexcms-share-assets-enabled">
                Actions
              </p>
            )}
          </div>
        </div>
        {downloads.map((download, i) => {
          return (
            <DownloadRow
              key={i}
              download={download}
              resource_display={resource_display}
              config={config}
              sharedAssetsEnabled={sharedAssetsEnabled}
            />
          );
        })}
      </section>
    </section>
  );
}
